import Partners from 'admin/components/Partners';

export const PartnersPage = () => {
  return <Partners showPageLayout={true} />;
};
